import { RootContainer } from '../../../../core/root_container';
import { CategoryMJsEnv } from '../../models/category_m_js_env';
import { RrBodyM1, RrBodyM2, RrBodyM3 } from './rr_body';
import { loadingDisplayNone, removeLoading} from '../../../../core/util/dom_util';
import { isSoloare } from '../../../../core/models/js_env';
import { Env } from '../../../../core/env';

export class CategoryMContainer extends RootContainer<CategoryMJsEnv> {
  constructor(model: CategoryMJsEnv) {
    super();

    if (!isSoloare(Env.SITE_TYPE) && model.isFromExternalSite) {
      // 外部流入の場合はタイマーを解除し、商品0件の場合はローディングモジュールを非表示とする
      clearTimeout(model.rrAreaProfileM1.timeoutId);
      if (model.rrAreaProfileM1.rrAreaItems.length === 0) {
        loadingDisplayNone(model.rrAreaProfileM1.placementName);
      }
    }

    this.mount(RrBodyM1, model.rrAreaProfileM1.placementName);
    this.mount(RrBodyM2, model.rrAreaProfileM2.placementName);
    this.mount(RrBodyM3, model.rrAreaProfileM3.placementName);

    // 初回描画
    this.update(model);

    if (!isSoloare(Env.SITE_TYPE) && model.isFromExternalSite) {
      // 外部流入の場合ローディングクラスを削除する
      removeLoading(model.rrAreaProfileM1.placementName);
    }

    const WindowCarousel = window._carousel;
    new WindowCarousel( // NOSONAR
      `#${model.rrAreaProfileM1.placementName},#${model.rrAreaProfileM2.placementName},#${model.rrAreaProfileM3.placementName}`
    );
  }
}
